export default __webpack_public_path__ + "static/media/products-grid-vertical-theme1.78369450.svg";